import { Flex, Heading } from '@chakra-ui/react'

const BaseOfferTaskWidget = ({ title, maxH = '300px', children }) => {
  return (
    <Flex
      shadow="md"
      borderWidth={['3px', '5px']}
      borderColor={'white'}
      borderRadius={['12px', '15px']}
      bg="white"
      w="100%"
      p={[3, 4]}
      gap={[3, 5]}
      maxH={{ base: 'none', md: maxH }}
      direction={'column'}
    >
      <Heading fontSize={['xl', '2xl']} lineHeight="short" mb="2">
        {title}
      </Heading>
      {children}
    </Flex>
  )
}

export default BaseOfferTaskWidget
